export const formConstants = {
  NEXT_SECTION: 'NEXT_SECTION',
  PREV_SECTION: 'PREV_SECTION',
  SUBMIT_FORM: 'SUBMIT_FORM',
  GO_TO_SECTION: 'GO_TO_SECTION',
  COMPLETE_SECTION: 'COMPLETE_SECTION',
  COMPLETED_SECTIONS: 'COMPLETED_SECTIONS',
}
